//-================ IMPORTS FOR GENERAL COMPONENT ================-\\
import { Component, OnInit, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';


//-================ IMPORTS FOR SERVICES ================-\\
import { LibraryFINService } from 'src/app/Services/Libraries/General-FIN/library-fin.service';


//-================ IMPORTS FOR CONSTANTS ================-\\

//-================ IMPORTS FOR DEPENDENCIES ================-\\
import moment from 'moment';
import Swal from 'sweetalert2';


//-================ IMPORTS FOR INTERFACES ================-\\
import { Data_Check, Filter_Check_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Filter_Check_FIN.interface';
import { TASK_ALL_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/All-Task-FIN.interface';
import { Response_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Response_FIN.interface';
import { Headers_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Headers-CCP.interface';
import { Task_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Create_WF/WorkFlow_FIN.interface';


@Component({
    selector: 'app-see-all-tasks-lib-fin',
    templateUrl: './see-all-tasks-lib-fin.component.html',
    styleUrls: ['./see-all-tasks-lib-fin.component.scss', '../../../../../Styles/GlobalStyles.css', '../../../../../Styles/LibrayGlobal.css', '../../../../../Styles/TasksGlobal.css'],
    standalone: false
})
export class SeeAllTasksLibFINComponent implements OnInit {

  //-========================= SECTION VARIABLES =========================-\\
  //+================== ARRAYS ==================+\\
  public List_All_Task: TASK_ALL_FIN[] = [];
  public SelectedList_All_Task: TASK_ALL_FIN[] = [];

  //+================== VARIABLES CREDENTIALS ==================+\\
  private ID_User_DB: number = Number(localStorage.getItem('ID_U_DB')) || 0;

  //+================== SEARCH ==================+\\
  public Task_Filter: string = '';

  public librarySlug: string = 'fin';
  public libraryName: string = 'Processes';
  public baseRoute: string = '/Dashboard/FIN';

  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  private ColorConfirm: string = '#20a8e1';
  private ColorsCancel: string = '#fc6161';

  //+================== VARIABLES FOR MODULE PAGINATION ==================+\\
  public NumberPage: number = 1; // variable to number page in ngx - pagination
  public ItemfoPage: number = 5; // variable for item per page

  public LoadPage: boolean = false;

  //+================== VARIABLES FOR HEADERS TASK ==================+\\
  public HeadersTask: Headers_CCP[] = [
    { ID: 1, Name: 'Nombre de tarea', Position: 1, Visible: true, Key_Header: 'NAT' },
    { ID: 1, Name: 'asignación', Position: 1, Visible: true, Key_Header: 'DAA' },
    { ID: 1, Name: 'Usuario que asigno', Position: 1, Visible: true, Key_Header: 'USA' },
    { ID: 1, Name: 'Objetivo del proceso', Position: 1, Visible: true, Key_Header: 'DES' },
  ];

  //+================== FOR FILTERS ==================+\\
  public Filter_Global_Check: Filter_Check_FIN = {
    Extension: [],
    Status: [],
    Revision_No: [],
    Approver1_Name: [],
    Approver2_Name: [],
    Approver3_Name: [],
    Approver4_Name: [],
    Contributor_Name: [],
  };


  //-========================= SERVICES =========================-\\

  private Service_FIN = inject(LibraryFINService);
  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.librarySlug = String(params['LibrarySlug'] || 'fin').toLowerCase();
      let rawName = String(params['LibraryName'] || (this.librarySlug === 'fin' ? 'Processes' : this.librarySlug.toUpperCase()));
      if (rawName === 'Finance Processes') {
        rawName = 'Processes';
      }
      this.libraryName = rawName;
      this.baseRoute = String(params['BaseRoute'] || '/Dashboard/FIN');
      this.Load_Component_Task();
    });

  }


  //&===================== FUNCTIONS FOR LOAD COMPONENT =====================&\\

  private async Load_Component_Task(): Promise<void> {

    this.LoadPage = false;

    const Loader = document.getElementById('Loader') as HTMLDivElement;
    Loader.classList.add('active');

    const ResGetTasks: Response_FIN = await firstValueFrom(this.Service_FIN.Get_Task_Of_User({ ID_Involved_User: this.ID_User_DB, Status: 1, IsConsultViewTask: true }, this.librarySlug));


    if (ResGetTasks.success) {
      this.LoadPage = true;
      const All_Task = ResGetTasks.operation;

      this.List_All_Task = All_Task;

      Loader.classList.remove('active');

      this.Generate_Filters();

    } else {
      this.LoadPage = true;
      Loader.classList.remove('active');

      Swal.fire({
        title: 'Ocurrió un error',
        text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
    }

  }

  //&===================== END FUNCTIONS FOR LOAD COMPONENT =====================&\\



  //&===================== FUNCTIONS FOR GENERAL COMPONENT =====================&\\

  public Is_Expired_Task(Task: TASK_ALL_FIN): string {
    const Current_Date = moment().utc();
    const Date_add = moment(Task.Date_Start).utc().add(3, 'day');

    return (Date_add > Current_Date) ? "" : "Expired";
  }

  //-================== FUNCTTION FOR GET EXPIRATION MESSAGE ==================-\\
  public ShowExpiredMessage(Task: TASK_ALL_FIN, event?: Event): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    
    console.log("Mostrando modal de tarea vencida para:", Task.Name);
    
    const Date_add = moment(Task.Date_Start).utc().add(3, 'day');
    Swal.fire({
      icon: 'warning',
      title: 'Tarea Vencida',
      text: `La tarea venció el día ${Date_add.format('DD/MM/YYYY')} a las ${Date_add.format('hh:mm:ss a')}`,
      confirmButtonColor: this.ColorConfirm
    });
  }

  //-================== FUNCTTION FOR FORMAT DATE CREATED ==================-\\
  public DateTaskCreate(Date_Start: Date): string {
    return moment(Date_Start).utc().format('DD/MM/YYYY hh:mm:ss a')
  }

  //-================== FUNCTTION FOR GREEATING ==================-\\
  public GetGreeting(): string {

    let TextGTings: string = '';

    const Date_User = new Date();
    const Hour = Date_User.getHours();

    if (Hour >= 0 && Hour <= 5) {
      TextGTings = 'Buenas noches';
    } else if (Hour >= 6 && Hour <= 11) {
      TextGTings = 'Buenos días';
    } else if (Hour >= 12 && Hour <= 17) {
      TextGTings = 'Buenas tardes';
    } else if (Hour >= 18) {
      TextGTings = 'Buenas noches';
    }

    return TextGTings;
  }

  //-================ FUNCTION FOR NAME USER ================-\\
  public NameUser(): string {
    const Name_User: string = localStorage.getItem('Name_User') || "";
    return (Name_User.split(' ', 2)).join(' ');
  }

  //-================== FUNCTION FOR FILTERS ==================-\\
  private Generate_Filters(): void {

    this.Filter_Global_Check = {
      Extension: [],
      Status: [],
      Revision_No: [],
      Approver1_Name: [],
      Approver2_Name: [],
      Approver3_Name: [],
      Approver4_Name: [],
      Contributor_Name: [],
    };

    for (const FIN of this.List_All_Task as any) {

      FIN.Date_Created = moment(FIN.Date_Created).utc().toDate();
      FIN.Date_Expiration = moment(FIN.Date_Expiration).utc().toDate();

      FIN.F_Extension = { Value: FIN.Extension } as Data_Check;
      FIN.F_Status = { Value: FIN.Status } as Data_Check;
      FIN.F_Revision_No = { Value: FIN.Revision_No } as Data_Check;
      FIN.F_Approver1_Name = { Value: FIN.Approver1_Name } as Data_Check;
      FIN.F_Approver2_Name = { Value: FIN.Approver2_Name } as Data_Check;
      FIN.F_Approver3_Name = { Value: FIN.Approver3_Name } as Data_Check;
      FIN.F_Approver4_Name = { Value: FIN.Approver4_Name } as Data_Check;
      FIN.F_NameUser = { Value: FIN.Contributor_Name } as Data_Check;

      if (!this.Filter_Global_Check.Extension.some(item => item.Value === FIN.Extension) && FIN.Extension !== null) {
        this.Filter_Global_Check.Extension.push({ Value: FIN.Extension })
      }

      if (!this.Filter_Global_Check.Status.some(item => item.Value === FIN.Status) && FIN.Status !== null) {
        this.Filter_Global_Check.Status.push({ Value: FIN.Status })
      }

      if (!this.Filter_Global_Check.Revision_No.some(item => item.Value === FIN.Revision_No) && FIN.Revision_No !== null) {
        this.Filter_Global_Check.Revision_No.push({ Value: FIN.Revision_No })
      }

      if (!this.Filter_Global_Check.Approver1_Name.some(item => item.Value === FIN.Approver1_Name) && FIN.Approver1_Name !== null) {
        this.Filter_Global_Check.Approver1_Name.push({ Value: FIN.Approver1_Name })
      }

      if (!this.Filter_Global_Check.Approver2_Name.some(item => item.Value === FIN.Approver2_Name) && FIN.Approver2_Name !== null) {
        this.Filter_Global_Check.Approver2_Name.push({ Value: FIN.Approver2_Name })
      }

      if (!this.Filter_Global_Check.Approver3_Name.some(item => item.Value === FIN.Approver3_Name) && FIN.Approver3_Name !== null) {
        this.Filter_Global_Check.Approver3_Name.push({ Value: FIN.Approver3_Name })
      }

      if (!this.Filter_Global_Check.Approver4_Name.some(item => item.Value === FIN.Approver4_Name) && FIN.Approver4_Name !== null) {
        this.Filter_Global_Check.Approver4_Name.push({ Value: FIN.Approver4_Name })
      }

      if (!this.Filter_Global_Check.Contributor_Name.some(item => item.Value === FIN.Contributor_Name) && FIN.Contributor_Name !== null) {
        this.Filter_Global_Check.Contributor_Name.push({ Value: FIN.Contributor_Name })
      }

    }


  }

  //-================== FUNCTION FOR UPDATE REJECTED DOCUMENT ==================-\\
  public async UpdateDocument(Task: TASK_ALL_FIN): Promise<void> {
    const Loader = document.getElementById('Loader') as HTMLDivElement;
    Loader.classList.add('active');
    try {
      const ResTask: any = await firstValueFrom(this.Service_FIN.Get_Info_Of_Task(Task.ID, this.librarySlug));
      if (ResTask.success) {
        Loader.classList.remove('active');
        const TaskDetails = ResTask.operation;
        const rawRoute: string = String(TaskDetails.Route_Destination || '').trim();
        const normalizedRoute: string = rawRoute.replace(/\\/g, '/').replace(/^\/+|\/+$/g, '');
        const routeParts: string[] = normalizedRoute.split('/').filter(Boolean);
        if (routeParts.length > 0 && /^raiz$/i.test(routeParts[0])) {
          routeParts.shift();
        }
        const lastPart = routeParts[routeParts.length - 1] || '';
        if (/\.[a-z0-9]{1,10}$/i.test(lastPart)) {
          routeParts.pop();
        }
        const RouteSend: string = routeParts.join('/');

        if (!RouteSend) {
          this.router.navigate([this.baseRoute]);
          return;
        }

        const queryParams: any = {
          path: RouteSend,
          openProperties: 1,
          documentId: TaskDetails.ID_WF,
          documentName: TaskDetails.Name
        };

        if (this.librarySlug !== 'fin') {
          this.router.navigate(['Dashboard/Lib', this.librarySlug], { queryParams });
          return;
        }

        const RouteEncode: string = encodeURIComponent(RouteSend);
        this.router.navigate([`Dashboard/FIN/FMLibraryFIN/${RouteEncode}`], { queryParams });
      } else {
        Loader.classList.remove('active');
      }
    } catch (e) {
      Loader.classList.remove('active');
      Swal.fire({
        title: 'Error',
        text: 'Ocurrió un error al buscar la ubicación del documento.',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });
    }
  }

  //&===================== END FUNCTIONS FOR GENERAL COMPONENT =====================&\\

}
